"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customStyles = void 0;
const primary_color_definitions_1 = require("../../../definitions/primary-color-definitions");
const customStyles = (mode, collapsed) => {
    const colors = {
        background: primary_color_definitions_1.primaryColors.transparent,
        backgroundHover: primary_color_definitions_1.primaryColors.orange80,
        defaultColor: primary_color_definitions_1.primaryColors.blue100primary,
        dropdownText: primary_color_definitions_1.primaryColors.blue100primary,
        itemFocus: primary_color_definitions_1.primaryColors.turquoise10,
        itemSelected: primary_color_definitions_1.primaryColors.turquoise30primary,
        textHover: primary_color_definitions_1.primaryColors.primaryWhite,
    };
    if (mode === 'operator') {
        colors.defaultColor = primary_color_definitions_1.primaryColors.primaryWhite;
        colors.textHover = primary_color_definitions_1.primaryColors.blue100primary;
        colors.backgroundHover = primary_color_definitions_1.primaryColors.blue30;
    }
    else if (mode === 'tenant') {
        colors.defaultColor = primary_color_definitions_1.primaryColors.blue100primary;
        colors.backgroundHover = primary_color_definitions_1.primaryColors.turquoise100;
    }
    else if (mode === 'landlord') {
        colors.defaultColor = primary_color_definitions_1.primaryColors.primaryWhite;
        colors.textHover = primary_color_definitions_1.primaryColors.blue100primary;
        colors.backgroundHover = primary_color_definitions_1.primaryColors.purple30;
    }
    else if (mode === 'developer') {
        colors.defaultColor = primary_color_definitions_1.primaryColors.primaryWhite;
        colors.textHover = primary_color_definitions_1.primaryColors.blue100primary;
        colors.backgroundHover = primary_color_definitions_1.primaryColors.blue30;
    }
    return {
        container: (provided, state) => {
            const containerStyles = collapsed ?
                {
                    position: 'absolute',
                    width: '52px',
                } : {
                position: 'relative',
                width: '100%',
            };
            return Object.assign({ '&:hover': {
                    color: colors.textHover,
                }, 
                // MOBILE
                '@media only screen and (max-width: 1030px)': {
                    backgroundColor: primary_color_definitions_1.primaryColors.transparent,
                    border: 'none',
                    boxShadow: 'none',
                    height: 'unset',
                }, 
                // DESKTOP XL ONLY
                '@media only screen and (max-width: 1450px) and (min-width: 1031px)': {
                    fontSize: '16px',
                    height: collapsed ? '44px' : '52px',
                    width: collapsed ? '44px' : '100%',
                }, 
                // DESKTOP AND LARGER
                '@media only screen and (min-width: 1031px)': {
                    '&:hover': {
                        '.aio-dropdown-icon': {
                            backgroundColor: colors.textHover,
                        },
                        '.feature-icon': {
                            backgroundColor: `${colors.textHover} !important`,
                        },
                        'backgroundColor': colors.backgroundHover,
                        'border': `2px solid ${colors.backgroundHover}`,
                        'color': colors.textHover,
                    },
                    '.aio-dropdown-icon': {
                        backgroundColor: state.isFocused ? colors.textHover : colors.defaultColor,
                    },
                    '.feature-icon': {
                        backgroundColor: `${state.isFocused ? colors.textHover : colors.defaultColor} !important`,
                    },
                    'backgroundColor': state.isFocused ? colors.backgroundHover : colors.background,
                    'border': `2px solid ${state.isFocused ? colors.backgroundHover : colors.defaultColor}`,
                    'borderRadius': '26px',
                }, 'color': state.isFocused ? colors.textHover : colors.defaultColor, 'fontFamily': 'Source Sans 3,arial,sans-serif', 'fontSize': '18px', 'height': '52px' }, containerStyles);
        },
        control: (provided, state) => {
            const controlStyles = collapsed ? {
                borderRadius: '50%',
                justifyContent: 'center',
                padding: '0',
            } : {
                justifyContent: 'space-between',
                padding: '0 25px 0 11px',
            };
            return Object.assign({ '@media only screen and (max-width: 1030px)': {
                    '.aio-dropdown-icon': {
                        backgroundColor: state.isFocused ? colors.textHover : colors.defaultColor,
                    },
                    '.feature-icon': {
                        backgroundColor: `${state.isFocused ? colors.textHover : colors.defaultColor} !important`,
                    },
                    'backgroundColor': state.isFocused ? colors.backgroundHover : colors.background,
                    'border': `2px solid ${state.isFocused ? colors.backgroundHover : colors.defaultColor}`,
                    'borderRadius': '26px',
                    'color': state.isFocused ? colors.textHover : colors.defaultColor,
                    'height': '52px',
                    'padding': '0 25px 0 11px',
                }, 'cursor': 'pointer', 'display': 'flex', 'height': '100%' }, controlStyles);
        },
        indicatorSeparator: () => {
            return {
                display: 'none',
            };
        },
        input: () => {
            return {
                '@media only screen and (max-width: 1200px)': {
                    fontSize: '16px',
                },
                'fontSize': '18px',
            };
        },
        menu: (provided, state) => {
            const menuStyles = collapsed ?
                {
                    left: '58px',
                    top: '-8px',
                    width: '300px',
                } : {
                width: '88%',
            };
            return Object.assign(Object.assign(Object.assign({}, provided), { '@media only screen and (max-width: 1030px)': {
                    backgroundColor: colors.background,
                    boxShadow: 'none',
                    margin: '8px 10px',
                    position: 'relative',
                    width: 'unset',
                }, 'boxShadow': '0 0 10px 0 rgba(0, 0, 0, 0.4)', 'color': colors.dropdownText, 'marginLeft': '6%' }), menuStyles);
        },
        menuList: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { '::-webkit-scrollbar': {
                    WebkitAppearance: 'none',
                    width: '11px',
                }, '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0, 0, 0, .5)',
                    border: '2px solid white',
                    borderRadius: '8px',
                }, '::-webkit-scrollbar-track': {
                    backgroundColor: 'white',
                    borderRadius: '8px',
                }, 'borderRadius': '5px', 'paddingBottom': '0', 'paddingTop': '0' });
        },
        option: (provided, state) => ({
            backgroundColor: state.isSelected ? colors.itemSelected :
                state.isFocused ? colors.itemFocus : primary_color_definitions_1.primaryColors.primaryWhite,
            cursor: 'pointer',
            display: 'block',
            fontSize: '16px',
            lineHeight: '20px',
            minHeight: '50px',
            overflow: 'hidden',
            padding: '15px',
            whiteSpace: 'normal',
        }),
        singleValue: () => {
            return {
                display: collapsed ? 'none' : 'block',
                overflow: 'hidden',
                textAlign: 'center',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            };
        },
        valueContainer: () => {
            return {
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
                padding: '0',
            };
        },
    };
};
exports.customStyles = customStyles;
//# sourceMappingURL=styles.js.map